var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.ready)?_c('apexchart',{attrs:{"width":"100%","type":"bar","options":_vm.options,"series":_vm.series}}):_c('center',[_c('strong',[_vm._v("Não encontramos dados.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }